export const defaultInterceptorErrorHandler: (error: any) => any = (error) => {
  void Promise.reject(error);
};
